import { render, staticRenderFns } from "./ManageInvestorAccountTab.vue?vue&type=template&id=1a62aa01"
import script from "./ManageInvestorAccountTab.vue?vue&type=script&lang=js"
export * from "./ManageInvestorAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports